import rgbTo, {
  ColorFormat,
} from 'modules/shares/Inspector/Sidebar/components/Color/utils'
import { capitalize } from '@sketch/utils'
import { gradientAngle } from './math'
import {
  Appearance,
  Gradient,
} from 'modules/shares/ArtboardDetailView/hooks/inspector/sketchSceneLib'

const gradientStopsCopy: (
  gradient: Gradient,
  colorFormat?: ColorFormat
) => string = (gradient, colorFormat) => {
  const stops = gradient.stops
    .sort((lhs, rhs) => lhs.position - rhs.position)
    .map((stop, i) => {
      const opacity = stop?.color?.alpha !== undefined ? stop?.color?.alpha : 1

      return (
        `\nColor Stop ${++i}` +
        `\nColor: ${rgbTo(colorFormat, stop.color)}` +
        (opacity !== 1 ? `\nOpacity: ${(opacity * 100).toFixed()}%` : ``) +
        `\nPosition: ${Math.round(stop.position * 100)}%\n`
      )
    })
  return stops.join('')
}

const copy = (
  gradient: Gradient,
  /**
   * The appearance object of the property using the gradient (fill or border)
   */
  parentPropAppearance?: Appearance,
  colorFormat?: ColorFormat
) => {
  const opacity = parentPropAppearance?.opacity ?? 1
  let gradientCopyValue = `Type: ${capitalize(
    gradient.type
  )}\nAngle: ${gradientAngle(gradient)}˚`

  gradientCopyValue += `\nOpacity: ${(opacity * 100).toFixed()}%`

  gradientCopyValue += `\n`
  gradientCopyValue += gradientStopsCopy(gradient, colorFormat)

  return gradientCopyValue
}

export default copy
